<template>
    <div>
        <b-row>
            <b-col cols="6">
                <b-form-group :label="$t('name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('surname')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('email')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.email) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('phone')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.phone) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('university_name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.university_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('faculty')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.faculty) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('program')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.program) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('application_type')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.application_type_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('course_code_option') + ' ' + $t('exam_name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.application_detail) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('student_status')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.student_status==='101'?$t('continue'):$t('graduate')) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('payment_status')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.payment_status==='H'?$t('no'):$t('yes')) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('payment_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.payment_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('amount')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.amount) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>

        </b-row>
    </div>
</template>

<script>
//Service

export default {
    props: {
        form: {
            type: Object
        }
    },

}
</script>
